import { render, staticRenderFns } from "./OrderFeature.vue?vue&type=template&id=1399c2a8"
import script from "./OrderFeature.vue?vue&type=script&lang=js"
export * from "./OrderFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports